<template>
  <div class="invoice-row table__row">
    <div class="invoice-row__cell cell-ref">
      <div class="label">
        {{ trans('user.invoice.table.id') }}
      </div>
      <div class="value">
        {{ invoice.full_invoice_ref }}
      </div>
    </div>
    <div class="invoice-row__cell">
      <div class="label">
        {{ trans('user.invoice.table.status') }}
      </div>
      <div class="value">
        <status-tag :label="status.wording" :color="status.color" />
      </div>
    </div>
    <div class="invoice-row__cell">
      <div class="label">
        {{ trans('user.invoice.table.issue_date') }}
      </div>
      <div class="value">
        {{ invoicedOn }}
      </div>
    </div>
    <div class="invoice-row__cell">
      <div class="label">
        {{ trans('user.invoice.table.due_date') }}
      </div>
      <div class="value">
        {{ dueDate }}
      </div>
    </div>
    <div class="invoice-row__cell">
      <div class="label">
        {{ trans('user.invoice.table.amount') }}
      </div>
      <div class="value">
        {{ currency(invoice.total) }} {{ trans('global.price_tax') }}
      </div>
    </div>
    <div class="invoice-row__cell">
      <div class="label">
        {{ trans('user.invoice.table.amount_vat') }}
      </div>
      <div class="value highlight">
        {{ currency(invoice.total_with_vat) }}
        {{ trans('global.price_tax_included') }}
      </div>
    </div>
    <div class="actions">
      <a
        v-if="invoice.pay_url"
        :href="invoice.pay_url"
        class="btn btn--small btn--primary"
        target="_blank"
      >
        {{ trans('user.invoice.actions.pay_invoice') }}
      </a>
      <a
        class="btn btn--small"
        :href="invoice.public_download_url"
        target="_blank"
      >
        {{ trans('user.invoice.actions.download_invoice') }}
      </a>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

import StatusTag from '@components/StatusTag.vue';
import translation from '@elements/translation';
import { currency } from '@elements/number-formatter';

export default {
  components: { StatusTag },
  mixins: [ translation ],
  props: {
    invoice: { type: Object, required: true },
  },
  computed: {
    invoicedOn() {
      return moment(this.invoice.invoiced_on).format('DD/MM/YYYY');
    },
    dueDate() {
      return moment(this.invoice.term_on).format('DD/MM/YYYY');
    },
    status() {
      if (this.invoice.paid_on) {
        return {
          wording: this.trans('user.invoice.status.paid'),
          color: 'green',
        };
      }

      if (moment(this.invoice.term_on) < moment()) {
        return {
          wording: this.trans('user.invoice.status.late'),
          color: 'red',
        };
      }

      if (this.invoice.balance !== this.invoice.total_with_vat) {
        return {
          wording: this.trans('user.invoice.status.partially_paid'),
          color: 'yellow',
        };
      }

      return { wording: this.trans('user.invoice.status.sent'), color: 'blue' };
    },
  },
  methods: {
    currency,
  },
};
</script>
